import { connect } from "react-redux";
import UpdatePoc from "./updatePoc";
import { bindActionCreators } from "redux";
import {
  getAssigneeList,
  savePoc
} from "services/redux/brandActivtion/sitesListing/action";
import {
  getDetails
} from 'services/redux/brandActivtion/sitesListing/action';

const mapStateToProps = (state) => ({
  assigneeList: state.baSiteListingReducer.assigneeList,
  viewDetails: state.baSiteListingReducer.viewDetails,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getAssigneeList,
      savePoc,
      getDetails
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(UpdatePoc);
